import(/* webpackMode: "eager", webpackExports: ["LiteModeScript"] */ "/frontend/src/components/LiteMode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeScript","ThemedToaster"] */ "/frontend/src/components/Theme.tsx");
;
import(/* webpackMode: "eager" */ "/frontend/src/styles/tailwind.css");
